module.exports = __webpack_public_path__ + "static/media/icon_lock.19afa65a.svg";